import * as React from 'react';
import { ButtonIcon } from '~ui/components/buttons/ButtonIcon/ButtonIcon';
import { IconGoBack } from '~ui/components/icons/specific/IconChevrons';
import { IconHome } from '~ui/components/icons/specific/IconHome';
import { useWaiterRouter } from '../../Routing/client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Button icon that navigates either
 *  - `back` rendering `IconGoBack`
 *  - or to `home` rendering `IconHomeScreen`
 */
export var HeaderNavigationButton = function HeaderNavigationButton(_ref) {
  var navigateTo = _ref.navigateTo,
      _ref$navigationIcon = _ref.navigationIcon,
      navigationIcon = _ref$navigationIcon === void 0 ? 'back' : _ref$navigationIcon;
  var router = useWaiterRouter();
  var onHeaderIconClick = React.useCallback(function () {
    if (!navigateTo) {
      return;
    }

    router.replace(navigateTo);
  }, [router, navigateTo]);

  if (!navigateTo) {
    return null;
  }

  return /*#__PURE__*/_jsx(ButtonIcon, {
    shadow: "none",
    padding: "none",
    variant: "ghost",
    iconSize: "1.5rem",
    onClick: onHeaderIconClick,
    icon: navigationIcon === "home" ? IconHome : IconGoBack
  });
};